var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 6H11.3125M2.93155 1V3.08586M9.9375 1V3.08573M9.9375 3.08573H3.0625C1.92341 3.08573 1 4.00674 1 5.14286V10.9429C1 12.079 1.92341 13 3.0625 13H9.9375C11.0766 13 12 12.079 12 10.9429L12 5.14286C12 4.00674 11.0766 3.08573 9.9375 3.08573Z",
    stroke: "#CFCED4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cba9b471730e97ddcda483d192880ffb.svg";
export { ForwardRef as ReactComponent };